import { render } from "./DashboardPeriodSelect.vue?vue&type=template&id=2ee22124&scoped=true"
import script from "./DashboardPeriodSelect.vue?vue&type=script&lang=js"
export * from "./DashboardPeriodSelect.vue?vue&type=script&lang=js"

import "./DashboardPeriodSelect.vue?vue&type=style&index=0&id=2ee22124&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee22124"]])

export default __exports__